const state = {
    bankData: {},
};

export default state;